import { MapPin } from 'lucide-react'

export function StoreMarkerIcon({ storeType, size = 24 }: { storeType: string; size?: number }) {
	let pinOffset: string | undefined = undefined
	let pinFillColor: string | undefined = undefined
	let pinColor: string | undefined = undefined
	let pinSize = size

	if (storeType === 'Factory House') {
		pinSize = size
		pinFillColor = '#888888'
		pinColor = '#000000'
	}
	if (storeType === 'Brand House') {
		pinSize = size
		pinFillColor = '#F28085'
		pinColor = '#fc212c'
	}
	if (storeType === 'Dealer') {
		pinSize = size
		pinFillColor = '#c4c4ff'
		pinColor = '#0000FF'
	}
	if (storeType === 'PopUp') {
		pinSize = size
		pinFillColor = '#96ff96'
		pinColor = '#00FF00'
	}

	pinOffset = `mt-[-${Math.ceil(pinSize / 2)}px]`

	return <MapPin className={`${pinOffset}`} stroke={pinColor} fill={pinFillColor} size={pinSize} />
}
